import React from "react";
import "./LandingPage.css";
import mainImg from "../../../images/slider-img.png";
import heroWhite from "../../../images/hero-bg.png";
import PrevBtn from "../../../../src/images/prev.png"
import NextBtn from "../../../../src/images/next.png"
import "../../../../src/index.css";
import Button from "../../Button/Button"

const LandingPage = () => {
  return (
    <>
   
      <div className="background">
        <div className="main-hero-bg">
          <div className="landing-page-wrapper">
            <div className="main-heading-wrapper">
              <div className="main-heading">
                <h1 className="largeheading">Start Business with Our Company</h1>
                <p className="mediumtext">
                  sed do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua. Ut enim ad minim veniam, quisnostrud exercitation
                  ullamco laboris nisi
                </p>
                <Button/>
              </div>
            </div>
            <div className="main-img">
              {/* <img className="herowhite" src={heroWhite} alt="" /> */}
              <img className="mainImg" src={mainImg} alt="" />
            </div>
            <div className="prev-next-btn">
              <div className="prev-btn-wrapper">
                  <img className="prev-btn" src={PrevBtn} alt="" />
              </div>
              <div className="next-btn-wrapper">
                  <img className="next-btn" src={NextBtn} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
